export default "__VITE_ASSET__XFqCE5Qe__"